module.exports = __webpack_public_path__ + "static/media/Cinccino_gaussian2.5ff5be2d.png";